document.addEventListener('DOMContentLoaded', function () {
  // Convert absolute datetime to relative
  function timeAgo(date) {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const intervals = [
      { label: 'year', seconds: 31536000 },
      { label: 'month', seconds: 2592000 },
      { label: 'day', seconds: 86400 },
      { label: 'hour', seconds: 3600 },
      { label: 'minute', seconds: 60 },
      { label: 'second', seconds: 1 },
    ];

    for (const i of intervals) {
      const count = Math.floor(seconds / i.seconds);
      if (count > 0) {
        return `${count} ${i.label}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'just now';
  }

  // Update each date
  const timeElements = document.querySelectorAll('.gh-card-date');
  timeElements.forEach(timeEl => {
    const datetime = timeEl.getAttribute('datetime');
    timeEl.textContent = timeAgo(datetime);
  });
  
  // Clone all news items for seamless looping after initial render
  setTimeout(() => {
    const tickerContent = document.querySelector('.ticker-content');
    if (tickerContent) {
      // First make content visible
      tickerContent.style.opacity = '1';
      // Then clone items
      tickerContent.innerHTML += tickerContent.innerHTML;
    }
  }, 50);
});